import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const ContactUs = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header group={null} version={null} />
      <div style={{ backgroundColor: "#fff", minHeight: "100vh", padding: "40px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ marginBottom: "30px" }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                color: "#007bff",
                textDecoration: "underline",
                marginBottom: "20px",
              }}
            >
              ← Back
            </button>
            <h1 className="mission_heading" style={{ marginBottom: "30px", textAlign: "left" }}>
              Contact Us
            </h1>
          </div>

          <div>
          <p className="mission_subheading" style={{ marginBottom: "30px", textAlign: "left", color: "#555582" }}>
            We'd love to hear from you! Get in touch with us through any of the following ways:
          </p>

          <div style={{ marginBottom: "40px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "30px",
              }}
            >
              <div style={{ marginRight: "20px", display: "flex", alignItems: "center", height: "36px" }}>
                <img 
                  src="assets/images/shared/icn_address.svg" 
                  alt="Address"
                  style={{ flexShrink: 0, width: "20px", height: "20px", display: "block" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flex: 1,
                }}
              >
                <h3 className="mission_subheading" style={{ marginBottom: "10px", textAlign: "left", color: "#50288c", fontWeight: "700", marginTop: "0px", lineHeight: "36px" }}>
                  Address
                </h3>
                <span style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582" }}>
                  H No.13-14, 2nd floor, Kothnur Main Rd,
                </span>
                <span style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582" }}>
                  Opposite Corporation Bank,
                </span>
                <span style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582" }}>
                  JP Nagar 7th Phase, Bengaluru,
                </span>
                <span style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582" }}>
                  Karnataka - 560078
                </span>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "30px",
              }}
            >
              <div style={{ marginRight: "20px", display: "flex", alignItems: "center", height: "36px" }}>
                <img 
                  src="assets/images/shared/icn_email.svg" 
                  alt="Email"
                  style={{ flexShrink: 0, width: "20px", height: "20px", display: "block" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flex: 1,
                }}
              >
                <h3 className="mission_subheading" style={{ marginBottom: "10px", textAlign: "left", color: "#50288c", fontWeight: "700", marginTop: "0px", lineHeight: "36px" }}>
                  Email
                </h3>
                <a 
                  href="mailto:hello@heartfultech.com"
                  style={{ 
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#50288c",
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                >
                  hello@heartfultech.com
                </a>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "30px",
              }}
            >
              <div style={{ marginRight: "20px", display: "flex", alignItems: "center", height: "36px" }}>
                <img 
                  src="assets/images/shared/icn_call.svg" 
                  alt="Phone"
                  style={{ flexShrink: 0, width: "20px", height: "20px", display: "block" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flex: 1,
                }}
              >
                <h3 className="mission_subheading" style={{ marginBottom: "10px", textAlign: "left", color: "#50288c", fontWeight: "700", marginTop: "0px", lineHeight: "36px" }}>
                  Phone
                </h3>
                <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582" }}>
                  +91 9867458156
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;

